/**
 * 论文接口
 */

import request from "@/utils/request";
import { queryParams as qp } from "@/utils/function.js";

// 获取论文批次
export async function getPaperBatchList(data) {
  return request.get(`/paperBatch/getPaperBatchList${qp(data)}`);
}
// 获取论文批次专业
export async function getListByBatchId(data) {
  return request.get(`/paperBatchMajor/getListByBatchId${qp(data)}`);
}

// 论文报名
export async function paperSignUp(data) {
  return request.post("/paperStudentMajor/signUp", data);
}
// 获取报名数据
export async function getPaperStudentMajorVO(data) {
  return request.get(`/paperStudentMajor/getPaperStudentMajorVO${qp(data)}`);
}

// 驳回后重新报名
export async function paperMajorReSignUp(data) {
  return request.post("/paperStudentMajor/reSignUp", data);
}
// 上传缴费照片
export async function paperMajorPayUpload(data) {
  return request.post("/paperStudentMajor/payUpload", data);
}

// 论文培训报名
export async function trainSignUp(data) {
  return request.post("/paperStudentMajor/trainSignUp", data);
}
// 论文培训 上传缴费照片
export async function trainPayUpload(data) {
  return request.post("/paperStudentMajor/trainPayUpload", data);
}

// 答辩流程文件上传
export async function uploadFile(data) {
  return request.post("/paperStudentMajor/uploadFile", data);
}

// 下载证件
export async function paperCertDownload(data) {
  return request.get(`/paperStudentMajor/certDownload${qp(data)}`, {
    timeout: 10000,
    responseType: "blob",
  });
}

// 更新材料
export async function updatePaperStudentMajorDocument(data) {
  return request.post(`/paperStudentMajor/updateDocument`, data);
}

// 论文留言板
// 获取是否有新信息的状态
export async function getIsNotRead(data) {
  return request.get(`/paperReplyMessage/isNotRead${qp(data)}`);
}
// 设置为已读
export async function settingRead(data) {
  return request.post("/paperReplyMessage/settingRead", data);
}
// 论文答辩留言列表
export async function paperQueryByPage(data) {
  return request.get(`/paperReplyMessage/queryByPage${qp(data)}`);
}
// 发送留言
export async function paperSaveOrUpdate(data) {
  return request.post("/paperReplyMessage/saveOrUpdate", data);
}

// 是否已经报名学位论文
export async function getIsApply() {
  return request.get(`/paperStudentMajor/isApply`);
}
